import { render } from "./fb4.vue?vue&type=template&id=f2be976a&scoped=true"
import script from "./fb4.vue?vue&type=script&lang=js"
export * from "./fb4.vue?vue&type=script&lang=js"

import "./fb4.vue?vue&type=style&index=0&id=f2be976a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2be976a"]])

export default __exports__